<button
	id="{{ name }}BtnLink"
	class="btn-link"
	type="{{ isSubmit ? 'submit' : 'button' }}"
	[disabled]="isDisabled"
	[attr.aria-label]="ariaLabel"
	[attr.role]="buttonRole"
	[routerLink]="routerLink"
	(click)="handleOnClick($event)"
	[attr.aria-current]="isActive ? 'page' : null">
	<ng-content></ng-content>
	@if (showCaret) {
		<i class="fa fa-caret-right" aria-hidden="true"></i>
	}
</button>
